import styled from 'react-emotion'
import { Avatar } from '../../../../common/components/Avatar'

const UserMessage = styled.div({
  marginTop: 40,
  marginBottom: 40,
  fontSize: 28,
  lineHeight: 1.25,
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [Avatar]: {
    marginBottom: 20
  }
})

export default UserMessage
